import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import "./CRMPostventaV2Procesos.css";

const BASE_PATH = "/administracion/crm-postventa/seguimiento-2";

export const CRM_POSTVENTA_SEGUIMIENTO_V2_TABS = [
  { slug: "centro", label: "Centro operativo" },
  { slug: "onboarding", label: "Onboarding" },
  { slug: "zoco-check", label: "Zoco Check" },
  { slug: "sin-facturacion", label: "Sin facturacion" },
  { slug: "recupero", label: "Recupero" },
  { slug: "extraviada", label: "Extraviada" },
  { slug: "automatizacion", label: "Automatizacion" },
  { slug: "derivaciones", label: "Derivaciones" },
  { slug: "historial", label: "Historial" },
];

export default function CrmPostventaSeguimientoV2Layout() {
  return (
    <section className="crm-postventa-page" translate="no">
      <div className="container crm-postventa-shell py-4">
        <section className="crm-postventa-topbar crm-postventa-v2-layout-topbar">
          <div className="crm-postventa-topbar-copy">
            <span className="crm-postventa-kicker">CRM Postventa</span>
            <h2>Seguimiento 2</h2>
            <p className="crm-postventa-v2-layout-description">
              Centro operativo unificado para navegacion, seguimiento y automatizacion del motor V2.
            </p>
          </div>

          <nav className="crm-postventa-v2-layout-nav" aria-label="Modulos de Seguimiento 2">
            <div className="crm-postventa-v2-nav flex-nowrap">
              {CRM_POSTVENTA_SEGUIMIENTO_V2_TABS.map((item) => (
                <NavLink
                  key={item.slug}
                  to={`${BASE_PATH}/${item.slug}`}
                  className={({ isActive }) =>
                    `nav-link crm-postventa-v2-layout-link${isActive ? " active" : ""}`
                  }
                >
                  {item.label}
                </NavLink>
              ))}
            </div>
          </nav>
        </section>

        <Outlet />
      </div>
    </section>
  );
}
